import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-highlight-loader',
  templateUrl: './highlight-loader.component.html',
  styleUrls: ['./highlight-loader.component.scss']
})
export class HighlightLoaderComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
